<template>
    <div>
        <el-col :span="18" style="display:flex; flex-wrap:wrap;">
            <el-col :span="8" v-for="(orderPanel, index) in row.panels" :key="index" class="mh-div">
                <el-card class="panel-box">
                    <div slot="header">
                        <el-row style="margin-bottom: 0;">
                            <router-link
                                :to="{ name: 'sector', params: { buildingId: orderPanel.pivot.building_id, fieldId: orderPanel.pivot.field_id }}">
                                <el-col :span="16">
                                    {{ orderPanel.panel_name }}
                                </el-col>
                            </router-link>
                            <!--<el-popover trigger="hover" placement="bottom">-->
                            <!--<h3>Owner</h3>-->
                            <!--<hr>-->
                            <!--<p><strong>Name</strong>: {{ orderPanel.owner.name }}</p>-->
                            <!--<p><strong>Adresse</strong>: {{ orderPanel.owner.address }}, {{ orderPanel.owner.zip }} {{ orderPanel.owner.city }}</p>-->
                            <!--&lt;!&ndash;<hr>&ndash;&gt;-->
                            <!--&lt;!&ndash;<p>Besitzte Einheiten: {{ orderPanel.owner.number_of_owned_panels }}</p>&ndash;&gt;-->
                            <!--</el-popover>-->
                            <el-col v-if="orderPanel.pivot.is_gift" :span="3">
                                <span class="gift-logo"></span>
                            </el-col>

                            <el-col :span="3" :offset="orderPanel.pivot.is_gift ? 2 : 5">
                                <DeleteBtn @clicked="emitDeletePanel(orderPanel)" />
                            </el-col>
                        </el-row>
                    </div>

                    <el-row>
                        <el-col>
                            <strong>Sektor {{ orderPanel.field.field_number }}, Einheit {{
                                                    orderPanel.panel_number }}</strong>
                            <br><br>
                            <strong>Adresse</strong>: <br>
                            <address>{{ row.building_address }}</address>
                            <br>
                            <div v-if="orderPanel.pivot.is_gift">
                                <el-popover trigger="hover" placement="bottom">
                                    <strong>Strasse</strong>: {{ orderPanel.owner.street }} {{
                                                        orderPanel.owner.house_nr }}
                                    <br>
                                    <strong>PLZ</strong>: {{ orderPanel.owner.zip }}
                                    <br>
                                    <strong>Stadt</strong>: {{ orderPanel.owner.city}}
                                    <!--<hr>-->
                                    <!--<p>Modules owned: {{ row.customer.number_of_owned_panels }}</p>-->
                                    <div slot="reference" class="name-wrapper">
                                        <strong>Geschenk für</strong>:
                                        <el-tag size="medium">{{ orderPanel.owner.name }}</el-tag>
                                    </div>
                                </el-popover>
                            </div>
                            <div v-else style="padding: 6px;">
                                <br>
                            </div>
                        </el-col>
                    </el-row>
                    <strong>Preis</strong>: {{ get_wording('Währung', row.supplier_id) }}
                    {{ orderPanel.pivot.panel_price }}
                </el-card>
            </el-col>
        </el-col>
        <el-col :span="6">
            <InputTemplate :commentProp="row.comment" @commentChange="changeComment($event, row.id)" ></InputTemplate>
        </el-col>
    </div>
</template>
<script>
    import {
        mapGetters,
    } from 'vuex';
    import DeleteBtn from '../../atoms/button/DeleteBtn';
    import InputTemplate from '../order/InputTemplate';

    export default {
        components: {
            DeleteBtn, InputTemplate,
        },
        computed: {
            ...mapGetters(['get_orders', 'get_suppliers', 'user_is_admin', 'user_is_supplier', 'get_wording']),
        },
        name: 'RowTemplate',
        props: ['row'],
        methods: {
            changeComment (comm, id) {
                this.comment = comm;
                this.emitComment(id, comm);
            },
            emitComment (orderId, comment) {
                // eslint-disable-next-line no-console
                this.$emit('emitComment', { orderId, comment });
            },
            emitDeletePanel (panelId) {
                // eslint-disable-next-line no-console
                this.$emit('emitDeletePanel', panelId);
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/pages/order/RowTemplate.vue